import Repository from './Repository';
import { ReportModel } from '@/store/types';

const resource: string = '/reports';

export class ReportsRepository {
  public static getByNetworkId(networkId: string) {
    return Repository.get<ReportModel[]>(`/networks/${networkId}${resource}`);
  }

  public static getByDeviceId(deviceId: string) {
    return Repository.get<ReportModel[]>(`/devices/${deviceId}${resource}`);
  }
}
